export default __webpack_public_path__ + "static/media/moly.4c3f0df5.jpeg";